import type { FunctionComponent } from 'react';
import { useService } from '@xstate/react';
import PersonaContext from './PersonaContext';
import PersonaDetailsScreen from './PersonaDetailsScreen';
import interpreter from '../../state/service';
import DialogTransitionRoute from '../../utils/DialogTransitionRoute';

export interface Props {}

const Personas: FunctionComponent<Props> = () => {
	const [state, send] = useService(interpreter);

	return (
		<DialogTransitionRoute
			key="persona_details"
			state={state}
			stateId="persona"
		>
			<PersonaContext
				personaName={state.context.personaName}
				render={(persona) => (
					<PersonaDetailsScreen
						persona={persona}
						onBack={() => send('CLOSE')}
					/>
				)}
			/>
		</DialogTransitionRoute>
	);
};

export default Personas;
